module.exports = __webpack_public_path__ + "static/img/banner33.f2ce46a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner33.jpg
// module id = GHHj
// module chunks = 6